<section>
  <div class="table-responsive">
    <div class="container d-flex pb-2 my-2">
      <div class="flex-fill">
        <app-date-range sranges="today,yesterday,last7days,last30days,last90days,last180days,last365days"
          [default-range]="'today'" [(start)]="criteria.from" [(end)]="criteria.to" (change)="load()">
        </app-date-range>
      </div>
      <div>
        <input type="checkbox" [(ngModel)]="criteria.justStarred" (change)="load()"> فقط ستاره‌دارها
      </div>
      <div>
        حداقل امتیاز<input type="number" [(ngModel)]="criteria.minScore" (debounce)="load()" />
      </div>
      <div>
        حداکثر امتیاز<input type="number" [(ngModel)]="criteria.maxScore" (debounce)="load()" />
      </div>
    </div>
    <div *ngIf="result">
      <div class="mt-2 pt-2 border-top">
        <!-- <h4 class="kp-title-line">آمار کلی</h4>
        <table class="container-capped table table-striped table-bordered table-sm">
          <thead>
            <tr>
              <td>تعداد کل</td>
              <td>پاسخ داده شده</td>
              <td>پاسخ کاربر</td>
              <td>ثبت اپراتور</td>
              <td>پاسخ داده نشده</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{result.stats.all|number}}</td>
              <td>{{result.stats.answered["1"]?.DocCount|number}}</td>
              <td>{{result.stats.answered["1"]?.answerBy["user"]|number}}</td>
              <td>{{result.stats.answered["1"]?.answerBy["operator"]|number}}</td>
              <td>{{result.stats.answered["0"]?.DocCount|number}}</td>
            </tr>
          </tbody>
        </table> -->


        <h4 class="kp-title-line">آمار پاسخ‌ها</h4>
        <table class="container-capped table table-striped table-bordered table-sm">
          <thead>
            <tr>
              <td>تعداد</td>
              <td>Promoter</td>
              <td>Passive</td>
              <td>Detractor</td>
              <td>NPS</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{result.npsList.length|number}}</td>
              <td>{{result.promoters|number}}</td>
              <td>{{result.passives|number}}</td>
              <td>{{result.detractors|number}}</td>
              <td dir="ltr" class="fw-bold">{{result.score|number}}</td>
            </tr>
          </tbody>
        </table>

        <h4 class="kp-title-line">جزئیات پاسخ‌ها</h4>
        <table class="container-capped table table-striped table-bordered table-sm fs-sm">
          <thead>
            <tr>
              <td>ستاره‌دار</td>
              <!-- <td>کد</td>
              <td>عنوان</td>
              <td>ثبت</td>
              <td>بودجه</td> -->
              <td>امتیاز</td>
              <td>کاربر</td>
              <td>دلیل</td>
              <td>زمان</td>
              <td>جزئیات</td>
              <!-- <td>استان</td>
              <td>شهر</td>
              <td>شرکت</td>
              <td>نام</td>
              <td>موبایل</td>
              <td>کلیک</td>
              <td>تماس</td>
              <td>اپلای</td>
              <td>آلرت</td> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let nps of result.npsList">
              <td>
                <i class="fa fa-star" [class.f-yellow]="nps?.IsStarred" (click)="star(nps)"></i>
              </td>
              <!-- <td>{{row.details?.Code}}</td>
              <td>{{row.details?.Title}}</td>
              <td>{{row.details?.RegisterTime | pdate:'[yy]/[mm]/[dd]'}}</td>
              <td>{{row.details?.Budget|number}}</td> -->
              <td>
                {{nps?.Score}}
                <i class="fa" [class.fa-thumbs-up]="nps?.Score>=9" [class.fa-thumbs-down]="nps?.Score<=6"
                  [class.f-green]="nps?.Score>=9" [class.f-red]="nps?.Score<=6"></i>
              </td>
              <td>
                <a *ngIf="nps.UserId!=Guid.Empty" class="btn btn-link btn-sm fs-sm f-blue" target="_blank" [routerLink]="['/', 'admin', 'user']"
                [queryParams]="{q: nps.UserId}">{{nps.UserSummary?.name || 'بدون نام'}}</a>
              </td>
              <td>{{nps?.Comment}}</td>
              <td dir="ltr">{{nps?.AnswerTime | pdate:'[yy]/[mm]/[dd] [hh]:[MM]'}}</td>
              <td>
                <i class="fa fa-plus pointer" (click)="nps._showData=!nps._showData"></i>
                <pre class="text-left fs-sm white-bg p-2 overflow-auto" dir="ltr" style="max-width: 600px;"
                  *ngIf="nps._showData">
                {{nps | json}}
              </pre>
              </td>
              <!-- <td>{{row.details?.State}}</td>
              <td>{{row.details?.City}}</td>
              <td>{{row.details?.Company}}</td>
              <td>{{row.details?.Name}}</td>
              <td>{{row.details?.Mobile}}</td>
              <td>
                <div *ngIf="row.details?.Clicks?.Views" class="pointer"
                  (click)="row.details?.Clicks?.Views._show = !row.details?.Clicks?.Views?._show">
                  {{row.details?.Clicks?.Views?.DocCount|number}}
                  <i class="fa fa-angle-down mr-1"></i>
                </div>
                <div class="p-1 border" *ngIf="row.details?.Clicks?.Views?._show">
                  <div *ngFor="let source of row.details?.Clicks?.Views?.Sources">{{source}}</div>
                </div>
              </td>
              <td>
                <div *ngIf="row.details?.Clicks?.Contacts" class="pointer"
                  (click)="row.details?.Clicks?.Contacts._show = !row.details?.Clicks?.Contacts?._show">
                  {{row.details?.Clicks?.Contacts?.DocCount|number}}
                  <i class="fa fa-angle-down mr-1"></i>
                </div>
                <div class="p-1 border" *ngIf="row.details?.Clicks?.Contacts?._show">
                  <div *ngFor="let source of row.details?.Clicks?.Contacts?.Sources">{{source}}</div>
                </div>
              </td>
              <td>
                <div *ngIf="row.details?.Applies" class="pointer"
                  (click)="row.details?.Applies._show = !row.details?.Applies?._show">
                  {{row.details?.Applies?.DocCount|number}}
                  <i class="fa fa-angle-down mr-1"></i>
                </div>
                <div class="p-1 border" *ngIf="row.details?.Applies?._show">
                  <div *ngFor="let source of row.details?.Applies?.Sources">{{source}}</div>
                </div>
              </td>
              <td>
                <div *ngIf="row.details?.Alerts" class="pointer"
                  (click)="row.details?.Alerts._show = !row.details?.Alerts?._show">
                  {{row.details?.Alerts?.DocCount|number}}
                  <i class="fa fa-angle-down mr-1"></i>
                </div>
                <div class="p-1 border mb-1" *ngIf="row.details?.Alerts?._show">
                  <div *ngFor="let channel of row.details?.Alerts?.Channels">{{channel}}</div>
                </div>
                <div class="p-1 border" *ngIf="row.details?.Alerts?._show">
                  <div *ngFor="let type of row.details?.Alerts?.Types">{{type}}</div>
                </div>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

</section>